export default __webpack_public_path__ + "static/media/checkmark@3x.155cf4d5.png";